import type { ScaleLinear } from "d3";

type AnnotationProps = {
  yScale: ScaleLinear<number, number>;
  boundsWidth: number;
};

// Fallback for a section level with no colour of its own. Level 0 (Not Detained
// / Expired) deliberately shares it.
export const UNKNOWN_SECTION_COLOR = "#94a3b8"; // slate grey

// Section colors - distinct hues across cool spectrum for clear differentiation
export const SECTION_COLORS: Record<number, string> = {
  0: UNKNOWN_SECTION_COLOR, // Not Detained / Expired
  1: "#fb923c", // Section 136 - amber/orange
  2: "#2dd4bf", // Section 5(4) - teal
  3: "#22d3ee", // Section 5(2) - cyan
  4: "#60a5fa", // Section 4 - blue
  5: "#818cf8", // Section 2 - indigo
  6: "#c084fc", // Section 3 - violet
  7: "#f472b6", // Section 17A (Recalled) - pink
  8: "#e879f9", // Section 17A/CTO - fuchsia
};

export const Annotation = ({ yScale, boundsWidth }: AnnotationProps) => {
  const sections = [
    { y: 0, color: SECTION_COLORS[0] },
    { y: 1, color: SECTION_COLORS[1] },
    { y: 2, color: SECTION_COLORS[2] },
    { y: 3, color: SECTION_COLORS[3] },
    { y: 4, color: SECTION_COLORS[4] },
    { y: 5, color: SECTION_COLORS[5] },
    { y: 6, color: SECTION_COLORS[6] },
    { y: 7, color: SECTION_COLORS[7] },
    { y: 8, color: SECTION_COLORS[8] },
  ];

  return (
    <>
      {sections.map(({ y, color }) => (
        <rect
          key={y}
          x={0}
          y={yScale(y + 1)}
          height={yScale(y) - yScale(y + 1)}
          width={boundsWidth}
          fill={color}
          opacity={0.15}
        />
      ))}
      <line
        x1={0}
        y1={yScale(0)}
        y2={yScale(0)}
        x2={boundsWidth}
        stroke={"#cbd5e1"}
        strokeWidth={0.5}
      />
      <line
        x1={0}
        y1={0}
        y2={yScale(0)}
        x2={0}
        stroke={"#cbd5e1"}
        strokeWidth={0.5}
      />
    </>
  );
};
